import React from "react";
import { Link } from "react-router-dom";
import { AdminPaths } from "./Paths";

export function DashboardLink() {
  return (
    <div className="has-text-centered" style={{ marginTop: "1em" }}>
      <Link to={AdminPaths.AdminDashboard}>Back to Dashboard</Link>
    </div>
  );
}
